var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ckeditor',{attrs:{"editor":_vm.editor,"config":_vm.conf},on:{"input":_vm.onEditorInput},model:{value:(_vm.hidden_value),callback:function ($$v) {_vm.hidden_value=$$v},expression:"hidden_value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }